'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { isCapacitor } from '@/lib/platformUtils';

// Mirrors the maintenance-gated prefixes in src/proxy.ts — only sessions on
// these routes get bounced to /maintenance when a 503+maintenance response
// arrives on any API call. Marketing/public pages stay up even though their
// API calls may also 503 during maintenance.
const GATED_PREFIXES = ['/client-zone', '/dashboard', '/profile', '/auth/login', '/auth/signup'];

export default function MaintenanceRedirectListener() {
  const pathname = usePathname();

  useEffect(() => {
    let redirected = false;

    const onMaintenance = (event: Event) => {
      if (redirected) return;
      if (!GATED_PREFIXES.some((p) => pathname.startsWith(p))) return;
      redirected = true;

      const detail = (event as CustomEvent<{ scheduledUntil?: string | null; message?: string | null }>).detail;
      const url = new URL('/maintenance', window.location.origin);
      if (isCapacitor()) url.searchParams.set('capacitor', 'true');
      if (detail?.scheduledUntil) url.searchParams.set('until', detail.scheduledUntil);
      if (detail?.message) url.searchParams.set('msg', detail.message);
      window.location.href = url.toString();
    };

    window.addEventListener('ta:maintenance', onMaintenance);
    return () => window.removeEventListener('ta:maintenance', onMaintenance);
  }, [pathname]);

  return null;
}
